module.exports = __webpack_public_path__ + "static/media/icTikTokSquare.9ce9fa31.png";